'use client';

import { useErrorReporter } from '@/hooks/useErrorReporter';

/**
 * Client component that registers global error handlers.
 * Include once in the root layout for app-wide error reporting.
 */
export default function ErrorReporterProvider() {
  useErrorReporter();
  return null;
}
